import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { removeFromCompare, clearCompare } from '../../shared/store/compareSlice';

import './CompareBar.scss';

const CompareBar = () => {
  const comparePlayers = useSelector(({ compare }) => compare.players);
  const dispatch = useDispatch();
  const history = useHistory();

  if (!comparePlayers.length) return null;

  const canCompare = comparePlayers.length >= 2;

  return (
    <div className="compare-bar">
      <div className="compare-bar__inner">
        <div className="compare-bar__info">
          <i className="far fa-clone" />
          <span className="compare-bar__count">
            Compare ({comparePlayers.length}/4 selected)
          </span>
        </div>

        <div className="compare-bar__chips">
          {comparePlayers.map(p => (
            <span key={p._id} className="compare-bar__chip">
              <span className="compare-bar__chip-name">
                {p.firstName} {p.lastName}
              </span>
              <button
                type="button"
                className="compare-bar__chip-remove"
                onClick={() => dispatch(removeFromCompare(p._id))}
                title="Remove"
              >
                <i className="fas fa-times" />
              </button>
            </span>
          ))}
        </div>

        <div className="compare-bar__actions">
          <button
            type="button"
            className="compare-bar__clear"
            onClick={() => dispatch(clearCompare())}
          >
            Clear
          </button>
          <button
            type="button"
            className={`compare-bar__btn ${!canCompare ? 'compare-bar__btn--disabled' : ''}`}
            disabled={!canCompare}
            onClick={() => canCompare && history.push('/compare')}
          >
            {canCompare ? (
              <>
                <i className="fas fa-columns" /> Compare Players
              </>
            ) : (
              'Select at least 2'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
